import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, FileText, AlertCircle } from 'lucide-react';
import Disclaimer from '../components/Disclaimer';
import Header from '../components/Header';
import Footer from '../components/Footer';

const Terms = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <Disclaimer />
      <Header />
      
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Link to="/" data-discover="true" className="inline-flex items-center text-purple-600 hover:text-purple-700 mb-8">
          <ArrowLeft className="w-4 h-4 mr-2" />
          Retour à l'accueil
        </Link>

        <article className="bg-white rounded-2xl shadow-lg p-8 md:p-12">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-12 h-12 bg-purple-100 rounded-lg flex items-center justify-center">
              <FileText className="w-6 h-6 text-purple-600" />
            </div>
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900">
              Conditions Générales d'Utilisation
            </h1>
          </div>
          
          <div className="prose prose-lg max-w-none text-gray-700 space-y-6 leading-relaxed">
            <p className="text-sm text-gray-500 mb-8">
              Dernière mise à jour : 8 décembre 2025
            </p>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">1. Acceptation des Conditions</h2>
              <p>
                En accédant et en utilisant le site web lyonpicks.com ("le Site"), vous acceptez d'être lié par ces Conditions Générales 
                d'Utilisation ("CGU"). Si vous n'acceptez pas ces conditions, veuillez ne pas utiliser le Site.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">2. Description du Service</h2>
              <p>
                Lyon Picks est un site indépendant de comparaison et d'évaluation des sites de paris en ligne agréés en France. Nous fournissons 
                des informations, des guides, des avis et des actualités pour aider les utilisateurs à faire des choix éclairés concernant 
                les paris en ligne.
              </p>
              <p>
                Nous ne sommes pas un site de paris en ligne et n'acceptons pas de paris. Nous ne gérons pas de comptes de parieurs et ne 
                traitons pas de transactions financières liées aux paris.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 flex items-center gap-2">
                <AlertCircle className="w-6 h-6 text-purple-600" />
                3. Restrictions d'Âge et de Juridiction
              </h2>
              <p>
                L'utilisation de ce Site est réservée aux personnes âgées de 18 ans ou plus. En utilisant le Site, vous déclarez et garantissez 
                que vous avez au moins 18 ans et que vous avez le droit légal d'utiliser ce Site selon les lois de votre juridiction.
              </p>
              <p>
                Les paris en ligne sont réglementés différemment selon les pays. Il est de votre responsabilité de vérifier que les paris en 
                ligne sont légaux dans votre juridiction avant d'utiliser les services des sites que nous recommandons.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">4. Liens d'Affiliation</h2>
              <p>
                Certains liens présents sur notre Site sont des liens d'affiliation. Cela signifie que si vous cliquez sur ces liens et 
                vous inscrivez sur un site de paris, nous pouvons recevoir une commission. Cette commission n'affecte jamais nos opinions, 
                nos évaluations ou nos recommandations.
              </p>
              <p>
                Nous nous efforçons de fournir des informations objectives et précises, indépendamment de nos relations d'affiliation. Tous les 
                sites que nous recommandons sont agréés par l'Autorité Nationale des Jeux (ANJ) en France.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">5. Exactitude des Informations</h2>
              <p>
                Nous nous efforçons de fournir des informations exactes et à jour, mais nous ne garantissons pas l'exactitude, l'exhaustivité 
                ou l'actualité de toutes les informations sur le Site. Les offres de bonus, les conditions et les cotes peuvent changer à tout 
                moment sans préavis.
              </p>
              <p>
                Il est de votre responsabilité de vérifier les informations actuelles directement auprès des sites de paris avant de prendre 
                toute décision. Nous ne sommes pas responsables des pertes ou dommages résultant de l'utilisation d'informations obsolètes ou 
                inexactes.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">6. Propriété Intellectuelle</h2>
              <p>
                Tout le contenu du Site, y compris mais sans s'y limiter, les textes, graphiques, logos, images, et logiciels, est la propriété 
                de Lyon Picks ou de ses concédants de licence et est protégé par les lois sur le droit d'auteur et autres lois sur la propriété 
                intellectuelle.
              </p>
              <p>
                Vous pouvez consulter et imprimer des pages du Site pour votre usage personnel et non commercial, mais vous ne pouvez pas 
                reproduire, distribuer, modifier ou créer des œuvres dérivées sans notre autorisation écrite préalable.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">7. Limitation de Responsabilité</h2>
              <p>
                Dans la mesure permise par la loi, Lyon Picks ne sera pas responsable de tout dommage direct, indirect, accessoire, spécial ou 
                consécutif résultant de l'utilisation ou de l'impossibilité d'utiliser le Site ou les informations qu'il contient.
              </p>
              <p>
                Nous ne sommes pas responsables des actions, contenus ou services des sites de paris tiers vers lesquels nous fournissons des 
                liens. Votre utilisation de ces sites tiers est à vos propres risques.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">8. Jeu Responsable</h2>
              <p>
                Nous encourageons fortement le jeu responsable. Les paris en ligne doivent être considérés comme une forme de divertissement, 
                pas comme un moyen de gagner de l'argent ou de résoudre des problèmes financiers.
              </p>
              <p>
                Si vous pensez avoir un problème de jeu, veuillez consulter notre page <Link to="/responsible-gaming" data-discover="true" className="text-purple-600 hover:text-purple-700 underline">Jeu Responsable</Link> 
                ou contactez des organisations d'aide comme SOS Joueurs (sosjoueurs.org) ou Joueurs Info Service (joueurs-info-service.fr).
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">9. Modifications du Site</h2>
              <p>
                Nous nous réservons le droit de modifier, suspendre ou interrompre tout ou partie du Site à tout moment, avec ou sans préavis. 
                Nous ne serons pas responsables envers vous ou tout tiers de toute modification, suspension ou interruption du Site.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">10. Modifications des CGU</h2>
              <p>
                Nous nous réservons le droit de modifier ces CGU à tout moment. Les modifications seront publiées sur cette page avec une date 
                de mise à jour révisée. Votre utilisation continue du Site après la publication des modifications constitue votre acceptation 
                des nouvelles conditions.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">11. Droit Applicable et Juridiction</h2>
              <p>
                Ces CGU sont régies par les lois françaises. Tout litige découlant de ou lié à ces CGU sera soumis à la juridiction exclusive 
                des tribunaux français.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-bold text-gray-900 mb-4">12. Contact</h2>
              <p>
                Pour toute question concernant ces Conditions Générales d'Utilisation, contactez-nous :
              </p>
              <div className="bg-gray-50 p-6 rounded-lg mt-4">
                <p><strong>Email :</strong> <a href="mailto:info@lyonpicks.com" className="text-purple-600 hover:text-purple-700 underline">info@lyonpicks.com</a></p>
                <p><strong>Téléphone :</strong> <a href="tel:+33289858716" className="text-purple-600 hover:text-purple-700 underline">+33 2 89 85 87 16</a></p>
                <p><strong>Adresse :</strong> Paris, France</p>
              </div>
            </section>
          </div>
        </article>
      </div>

      <Footer />
    </div>
  );
};

export default Terms;

